<div *ngIf="displayManagerInfo && data.unitManagerPerPeopleId" class="node-content">
    <img [hidden]="!data.unitManagerInfo?.pictureSrc" src="{{ data.unitManagerInfo?.pictureSrc }}" class="manager-image" />
    <div>{{ data.unitManagerInfo ? data.unitManagerInfo.text : '-' }}</div>
</div>
<div *ngIf="displayPersonnelCountNumbers && data.isUnit && data.activePersonnelCount">
    <div class="w-12 flex">
        <i class="pi pi-users count-number-text">&nbsp;{{ data.activePersonnelCount }}</i>
    </div>
    <div *ngIf="data.empTypeGroupedEmpCountList && data.empTypeGroupedEmpCountList.length > 0" class="w-12">
        <li *ngFor="let it of data.empTypeGroupedEmpCountList" class="emp-type-group-li">
            <span class="emp-type-group-span">{{ it.employeeTypeLongText }} : {{ it.count }}</span>
        </li>
    </div>
</div>
